import { render, staticRenderFns } from "./ClinicianAddPatientToProgram.vue?vue&type=template&id=4b66ef8c&scoped=true"
import script from "./ClinicianAddPatientToProgram.vue?vue&type=script&lang=js"
export * from "./ClinicianAddPatientToProgram.vue?vue&type=script&lang=js"
import style0 from "./ClinicianAddPatientToProgram.vue?vue&type=style&index=0&id=4b66ef8c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66ef8c",
  null
  
)

export default component.exports